import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AdministrationRoutes from 'src/routes/groups/AdministrationRoutes';
import CommunicationRoutes from 'src/routes/groups/CommunicationRoutes';
import CronRoutes from 'src/routes/groups/CronRoutes';
import ObserversRoutes from 'src/routes/groups/Observers';
import SeverityRoutes from 'src/routes/groups/SeverityRoutes';
import NotFound from 'src/pages/httpStatuses/NotFound';
import IndicatorsRoutes from 'src/routes/groups/IndicatorsRoutes';
import Dashboard from 'src/pages/dashboard';
import OccurrenceDetais from 'src/pages/occurrences/OccurrenceDetails';
import StoreRoutes from 'src/routes/groups/StoreRoutes';
import SignUp from 'src/pages/sign_up';
import LoginPage from 'src/pages/login';
import Showcase from 'src/pages/partners';

export default function MainRoutes() {
	return (
		<>
			<Routes>
				<Route
					path="/"
					element={<Dashboard />}
				/>
				<Route
					path="/cadastro"
					element={<SignUp />}
				/>
				<Route
					path="/login"
					element={<LoginPage />}
				/>
				<Route
					path="/partners"
					element={<Showcase />}
				/>
				<Route
					path="occurrence/:occurrence_id"
					element={<OccurrenceDetais />}
				/>
				{AdministrationRoutes()}
				{CommunicationRoutes()}
				{CronRoutes()}
				{ObserversRoutes()}
				{SeverityRoutes()}
				{IndicatorsRoutes()}
				{StoreRoutes()}
				<Route path="*" element={<NotFound />} />
			</Routes>
		</>
	);
}
